import React, { Component } from "react";

import { connect } from "react-redux";

import "./user-panel.css";
// import { BASE_S3 } from '../../../config/consts';

class UserPanel extends Component {
	render() {
		return (
			<div className="user-panel">
				<div className="pull-left image">
					<center>
						<i className="fa fa-user"
							style={{
								color: "white",
								textAlign: "center",
								fontSize: "4rem"
							}}
						/>
					</center>
				</div>
				<div className="pull-left info" style={{ paddingLeft: 5}}>
					<p style={{ color: "white" }}>{this.props.user.name}</p>
					<a href={window.location.href}>
						<i className="fa fa-circle text-success" /> Online
					</a>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.auth.user
	};
};

export default connect(mapStateToProps)(UserPanel);
